/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * Gateway IM - Unified Module
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BatchRegisterApiV1UnifiedBatchRegisterPostParams,
  BatchUserRegistrationResponse,
  BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost,
  BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams,
  BulkSearchApiV1UnifiedBulkSearchPostParams,
  BulkSearchUserRequest,
  ChangePasswordApiV1UnifiedChangePasswordPostParams,
  ChangePasswordRequest,
  ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams,
  ChangePhoneNumberRequest,
  ChangePhoneNumberResponse,
  CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams,
  CreateUsernameAndPasswordRequest,
  DeactivateUnifiedUserRequest,
  DeactivateUserApiV1UnifiedDeactivateUserPostParams,
  EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams,
  ForgotPasswordApiV1UnifiedValidateUserPostParams,
  ForgotPasswordRequest,
  GenerateDeactivationOTPRequest,
  GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams,
  GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams,
  GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams,
  GenerateProfileTokenRequest,
  GetAccountsListApiV1UnifiedAccountsListGetParams,
  GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  GetJobListApiV1UnifiedGetJobListGetParams,
  GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  HTTPValidationError,
  LogoutRequest,
  LogoutUnifiedUserApiV1UnifiedLogoutPostParams,
  LoginWithAdmissionIdRequest,
  LoginWithAdmissionIdResponse,
  LoginWithOtpRequest,
  LoginWithOtpResponse,
  MagicMockApiV1UnifiedUpdateProfilePutParams,
  MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams,
  MagicMockApiV2UnifiedLoginWithOtpPostParams,
  MultiUserRegistrationRequest,
  ProfilesPostRequest,
  ProfileRefreshTokenRequest,
  ProfileRefreshTokenRequestV3,
  RegisterUnifiedUserApiV1UnifiedRegisterPostParams,
  ResetPasswordRequest,
  ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams,
  SearchProfileRequest,
  SearchUserApiV1UnifiedSearchUserPostParams,
  SearchUserHandlerApiV2UnifiedSearchUserPostParams,
  UnifiedUserRegisterRequest,
  UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams,
  UpdatePhoneNumberRequest,
  ValidateUserRequest,
  VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams,
  VerifyPhoneRequest,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Verify OTP and log in (Login with OTP).
 * @summary Magicmock
 */
export const magicMockApiV1UnifiedLoginWithOtpPost = (
  data: LoginWithOtpRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<LoginWithOtpResponse>(
    { url: `/api/v1/unified/login-with-otp`, method: "POST", data, signal },
    options,
  );
};

export const getMagicMockApiV1UnifiedLoginWithOtpPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>,
    TError,
    { data: LoginWithOtpRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>,
  TError,
  { data: LoginWithOtpRequest },
  TContext
> => {
  const mutationKey = ["magicMockApiV1UnifiedLoginWithOtpPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>,
    { data: LoginWithOtpRequest }
  > = (props) => {
    const { data } = props ?? {};

    return magicMockApiV1UnifiedLoginWithOtpPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV1UnifiedLoginWithOtpPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>
>;

export type MagicMockApiV1UnifiedLoginWithOtpPostMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock
 */
export const useMagicMockApiV1UnifiedLoginWithOtpPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>,
      TError,
      { data: LoginWithOtpRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithOtpPost>>,
  TError,
  { data: LoginWithOtpRequest },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV1UnifiedLoginWithOtpPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * MagicMock is a subclass of Mock with default implementations
of most of the magic methods. You can use MagicMock without having to
configure the magic methods yourself.

If you use the `spec` or `spec_set` arguments then *only* magic
methods that exist in the spec will be created.

Attributes and the return value of a `MagicMock` will also be `MagicMocks`.
 * @summary Magicmock (patched: body instead of params, per-call request)
 */
export const magicMockApiV1UnifiedProfilesPost = (
  data: ProfilesPostRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/profiles`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data,
      signal,
    },
    options,
  );
};

export const getMagicMockApiV1UnifiedProfilesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>,
    TError,
    {
      data: ProfilesPostRequest;
      request?: SecondParameter<typeof customInstance>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>,
  TError,
  {
    data: ProfilesPostRequest;
    request?: SecondParameter<typeof customInstance>;
  },
  TContext
> => {
  const mutationKey = ["magicMockApiV1UnifiedProfilesPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>,
    {
      data: ProfilesPostRequest;
      request?: SecondParameter<typeof customInstance>;
    }
  > = (props) => {
    const { data, request } = props ?? {};

    return magicMockApiV1UnifiedProfilesPost(data, request ?? requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV1UnifiedProfilesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>
>;

export type MagicMockApiV1UnifiedProfilesPostMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock (patched: body instead of params, per-call request)
 */
export const useMagicMockApiV1UnifiedProfilesPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>,
      TError,
      {
        data: ProfilesPostRequest;
        request?: SecondParameter<typeof customInstance>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedProfilesPost>>,
  TError,
  {
    data: ProfilesPostRequest;
    request?: SecondParameter<typeof customInstance>;
  },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV1UnifiedProfilesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * MagicMock is a subclass of Mock with default implementations
of most of the magic methods. You can use MagicMock without having to
configure the magic methods yourself.

If you use the `spec` or `spec_set` arguments then *only* magic
methods that exist in the spec will be created.

Attributes and the return value of a `MagicMock` will also be `MagicMocks`.
 * @summary Magicmock (patched: body instead of params)
 */
export const magicMockApiV1UnifiedLoginWithAdmissionIdPost = (
  data: LoginWithAdmissionIdRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<LoginWithAdmissionIdResponse>(
    {
      url: `/api/v1/unified/login-with-admission-id`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data,
      signal,
    },
    options,
  );
};

export const getMagicMockApiV1UnifiedLoginWithAdmissionIdPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>,
    TError,
    { data: LoginWithAdmissionIdRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>,
  TError,
  { data: LoginWithAdmissionIdRequest },
  TContext
> => {
  const mutationKey = ["magicMockApiV1UnifiedLoginWithAdmissionIdPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>,
    { data: LoginWithAdmissionIdRequest }
  > = (props) => {
    const { data } = props ?? {};

    return magicMockApiV1UnifiedLoginWithAdmissionIdPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV1UnifiedLoginWithAdmissionIdPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>
  >;

export type MagicMockApiV1UnifiedLoginWithAdmissionIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock (patched: body instead of params)
 */
export const useMagicMockApiV1UnifiedLoginWithAdmissionIdPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>,
      TError,
      { data: LoginWithAdmissionIdRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedLoginWithAdmissionIdPost>>,
  TError,
  { data: LoginWithAdmissionIdRequest },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV1UnifiedLoginWithAdmissionIdPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * MagicMock is a subclass of Mock with default implementations
of most of the magic methods. You can use MagicMock without having to
configure the magic methods yourself.

If you use the `spec` or `spec_set` arguments then *only* magic
methods that exist in the spec will be created.

Attributes and the return value of a `MagicMock` will also be `MagicMocks`.
 * @summary Magicmock
 */
export const magicMockApiV1UnifiedUpdateProfilePut = (
  params: MagicMockApiV1UnifiedUpdateProfilePutParams,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/update-profile`,
      method: "PUT",
      // Send payload as JSON body instead of query params
      data: params,
    },
    options,
  );
};

export const getMagicMockApiV1UnifiedUpdateProfilePutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>,
    TError,
    { params: MagicMockApiV1UnifiedUpdateProfilePutParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>,
  TError,
  { params: MagicMockApiV1UnifiedUpdateProfilePutParams },
  TContext
> => {
  const mutationKey = ["magicMockApiV1UnifiedUpdateProfilePut"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>,
    { params: MagicMockApiV1UnifiedUpdateProfilePutParams }
  > = (props) => {
    const { params } = props ?? {};

    return magicMockApiV1UnifiedUpdateProfilePut(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV1UnifiedUpdateProfilePutMutationResult = NonNullable<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>
>;

export type MagicMockApiV1UnifiedUpdateProfilePutMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock
 */
export const useMagicMockApiV1UnifiedUpdateProfilePut = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>,
      TError,
      { params: MagicMockApiV1UnifiedUpdateProfilePutParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV1UnifiedUpdateProfilePut>>,
  TError,
  { params: MagicMockApiV1UnifiedUpdateProfilePutParams },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV1UnifiedUpdateProfilePutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get Accounts List
 */
export const getAccountsListApiV1UnifiedAccountsListGet = (
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/v1/unified/accounts-list`, method: "GET", params, signal },
    options,
  );
};

export const getGetAccountsListApiV1UnifiedAccountsListGetQueryKey = (
  params?: GetAccountsListApiV1UnifiedAccountsListGetParams,
) => {
  return [
    `/api/v1/unified/accounts-list`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAccountsListApiV1UnifiedAccountsListGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetAccountsListApiV1UnifiedAccountsListGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>
  > = ({ signal }) =>
    getAccountsListApiV1UnifiedAccountsListGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAccountsListApiV1UnifiedAccountsListGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>
>;
export type GetAccountsListApiV1UnifiedAccountsListGetQueryError =
  HTTPValidationError;

export function useGetAccountsListApiV1UnifiedAccountsListGet<
  TData = Awaited<
    ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
          >,
          TError,
          Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountsListApiV1UnifiedAccountsListGet<
  TData = Awaited<
    ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
          >,
          TError,
          Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAccountsListApiV1UnifiedAccountsListGet<
  TData = Awaited<
    ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Accounts List
 */

export function useGetAccountsListApiV1UnifiedAccountsListGet<
  TData = Awaited<
    ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetAccountsListApiV1UnifiedAccountsListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAccountsListApiV1UnifiedAccountsListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetAccountsListApiV1UnifiedAccountsListGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Logout Unified User
 */
export const logoutUnifiedUserApiV1UnifiedLogoutPost = (
  logoutRequest: LogoutRequest,
  params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/logout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: logoutRequest,
      params,
      signal,
    },
    options,
  );
};

export const getLogoutUnifiedUserApiV1UnifiedLogoutPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>,
    TError,
    {
      data: LogoutRequest;
      params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>,
  TError,
  {
    data: LogoutRequest;
    params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams;
  },
  TContext
> => {
  const mutationKey = ["logoutUnifiedUserApiV1UnifiedLogoutPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>,
    {
      data: LogoutRequest;
      params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return logoutUnifiedUserApiV1UnifiedLogoutPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutUnifiedUserApiV1UnifiedLogoutPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>
>;
export type LogoutUnifiedUserApiV1UnifiedLogoutPostMutationBody = LogoutRequest;
export type LogoutUnifiedUserApiV1UnifiedLogoutPostMutationError =
  HTTPValidationError;

/**
 * @summary Logout Unified User
 */
export const useLogoutUnifiedUserApiV1UnifiedLogoutPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>,
      TError,
      {
        data: LogoutRequest;
        params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof logoutUnifiedUserApiV1UnifiedLogoutPost>>,
  TError,
  {
    data: LogoutRequest;
    params: LogoutUnifiedUserApiV1UnifiedLogoutPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getLogoutUnifiedUserApiV1UnifiedLogoutPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Reset Unified User Password
 */
export const resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost = (
  resetPasswordRequest: ResetPasswordRequest,
  params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/reset-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resetPasswordRequest,
      params,
      signal,
    },
    options,
  );
};

export const getResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
      >,
      TError,
      {
        data: ResetPasswordRequest;
        params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
    >,
    TError,
    {
      data: ResetPasswordRequest;
      params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
      >,
      {
        data: ResetPasswordRequest;
        params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
    >
  >;
export type ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostMutationBody =
  ResetPasswordRequest;
export type ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostMutationError =
  HTTPValidationError;

/**
 * @summary Reset Unified User Password
 */
export const useResetUnifiedUserPasswordApiV1UnifiedResetPasswordPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
      >,
      TError,
      {
        data: ResetPasswordRequest;
        params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof resetUnifiedUserPasswordApiV1UnifiedResetPasswordPost>
  >,
  TError,
  {
    data: ResetPasswordRequest;
    params: ResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getResetUnifiedUserPasswordApiV1UnifiedResetPasswordPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Register Unified User
 */
export const registerUnifiedUserApiV1UnifiedRegisterPost = (
  unifiedUserRegisterRequest: UnifiedUserRegisterRequest,
  params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unifiedUserRegisterRequest,
      params,
      signal,
    },
    options,
  );
};

export const getRegisterUnifiedUserApiV1UnifiedRegisterPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>,
    TError,
    {
      data: UnifiedUserRegisterRequest;
      params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>,
  TError,
  {
    data: UnifiedUserRegisterRequest;
    params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams;
  },
  TContext
> => {
  const mutationKey = ["registerUnifiedUserApiV1UnifiedRegisterPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>,
    {
      data: UnifiedUserRegisterRequest;
      params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return registerUnifiedUserApiV1UnifiedRegisterPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterUnifiedUserApiV1UnifiedRegisterPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>
  >;
export type RegisterUnifiedUserApiV1UnifiedRegisterPostMutationBody =
  UnifiedUserRegisterRequest;
export type RegisterUnifiedUserApiV1UnifiedRegisterPostMutationError =
  HTTPValidationError;

/**
 * @summary Register Unified User
 */
export const useRegisterUnifiedUserApiV1UnifiedRegisterPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>,
      TError,
      {
        data: UnifiedUserRegisterRequest;
        params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof registerUnifiedUserApiV1UnifiedRegisterPost>>,
  TError,
  {
    data: UnifiedUserRegisterRequest;
    params: RegisterUnifiedUserApiV1UnifiedRegisterPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getRegisterUnifiedUserApiV1UnifiedRegisterPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Register Unified Users
 */
export const bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost = (
  bodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost,
  params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(
    `fileobject`,
    bodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost.fileobject,
  );

  return customInstance<unknown>(
    {
      url: `/api/v1/unified/bulk-register`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      params,
      signal,
    },
    options,
  );
};

export const getBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
      >,
      TError,
      {
        data: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
        params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
    >,
    TError,
    {
      data: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
      params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
      >,
      {
        data: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
        params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
    >
  >;
export type BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostMutationBody =
  BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
export type BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Register Unified Users
 */
export const useBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
      >,
      TError,
      {
        data: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
        params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof bulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost>
  >,
  TError,
  {
    data: BodyBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPost;
    params: BulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getBulkRegisterUnifiedUsersApiV1UnifiedBulkRegisterPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Verify And Validate Token
 */
export const verifyAndValidateTokenApiV1UnifiedVerifyTokenPost = (
  params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/v1/unified/verify-token`, method: "POST", params, signal },
    options,
  );
};

export const getVerifyAndValidateTokenApiV1UnifiedVerifyTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>
      >,
      TError,
      { params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>
    >,
    TError,
    { params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams },
    TContext
  > => {
    const mutationKey = ["verifyAndValidateTokenApiV1UnifiedVerifyTokenPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>
      >,
      { params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams }
    > = (props) => {
      const { params } = props ?? {};

      return verifyAndValidateTokenApiV1UnifiedVerifyTokenPost(
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>
    >
  >;

export type VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Verify And Validate Token
 */
export const useVerifyAndValidateTokenApiV1UnifiedVerifyTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>
      >,
      TError,
      { params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyAndValidateTokenApiV1UnifiedVerifyTokenPost>>,
  TError,
  { params: VerifyAndValidateTokenApiV1UnifiedVerifyTokenPostParams },
  TContext
> => {
  const mutationOptions =
    getVerifyAndValidateTokenApiV1UnifiedVerifyTokenPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Verify Phone Status
 */
export const verifyPhoneStatusApiV1UnifiedCheckPhonePost = (
  verifyPhoneRequest: VerifyPhoneRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/check-phone`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: verifyPhoneRequest,
      signal,
    },
    options,
  );
};

export const getVerifyPhoneStatusApiV1UnifiedCheckPhonePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>,
    TError,
    { data: VerifyPhoneRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>,
  TError,
  { data: VerifyPhoneRequest },
  TContext
> => {
  const mutationKey = ["verifyPhoneStatusApiV1UnifiedCheckPhonePost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>,
    { data: VerifyPhoneRequest }
  > = (props) => {
    const { data } = props ?? {};

    return verifyPhoneStatusApiV1UnifiedCheckPhonePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyPhoneStatusApiV1UnifiedCheckPhonePostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>
  >;
export type VerifyPhoneStatusApiV1UnifiedCheckPhonePostMutationBody =
  VerifyPhoneRequest;
export type VerifyPhoneStatusApiV1UnifiedCheckPhonePostMutationError =
  HTTPValidationError;

/**
 * @summary Verify Phone Status
 */
export const useVerifyPhoneStatusApiV1UnifiedCheckPhonePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>,
      TError,
      { data: VerifyPhoneRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof verifyPhoneStatusApiV1UnifiedCheckPhonePost>>,
  TError,
  { data: VerifyPhoneRequest },
  TContext
> => {
  const mutationOptions =
    getVerifyPhoneStatusApiV1UnifiedCheckPhonePostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update Mobile Number
 */
export const updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost = (
  updatePhoneNumberRequest: UpdatePhoneNumberRequest,
  params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/update-phone-number`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updatePhoneNumberRequest,
      params,
      signal,
    },
    options,
  );
};

export const getUpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
      >,
      TError,
      {
        data: UpdatePhoneNumberRequest;
        params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
    >,
    TError,
    {
      data: UpdatePhoneNumberRequest;
      params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams;
    },
    TContext
  > => {
    const mutationKey = ["updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
      >,
      {
        data: UpdatePhoneNumberRequest;
        params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
    >
  >;
export type UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostMutationBody =
  UpdatePhoneNumberRequest;
export type UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostMutationError =
  HTTPValidationError;

/**
 * @summary Update Mobile Number
 */
export const useUpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
      >,
      TError,
      {
        data: UpdatePhoneNumberRequest;
        params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateMobileNumberApiV1UnifiedUpdatePhoneNumberPost>
  >,
  TError,
  {
    data: UpdatePhoneNumberRequest;
    params: UpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getUpdateMobileNumberApiV1UnifiedUpdatePhoneNumberPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Deactivate User
 */
export const deactivateUserApiV1UnifiedDeactivateUserPost = (
  deactivateUnifiedUserRequest: DeactivateUnifiedUserRequest,
  params: DeactivateUserApiV1UnifiedDeactivateUserPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/deactivate-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deactivateUnifiedUserRequest,
      params,
      signal,
    },
    options,
  );
};

export const getDeactivateUserApiV1UnifiedDeactivateUserPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>,
    TError,
    {
      data: DeactivateUnifiedUserRequest;
      params: DeactivateUserApiV1UnifiedDeactivateUserPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>,
  TError,
  {
    data: DeactivateUnifiedUserRequest;
    params: DeactivateUserApiV1UnifiedDeactivateUserPostParams;
  },
  TContext
> => {
  const mutationKey = ["deactivateUserApiV1UnifiedDeactivateUserPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>,
    {
      data: DeactivateUnifiedUserRequest;
      params: DeactivateUserApiV1UnifiedDeactivateUserPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return deactivateUserApiV1UnifiedDeactivateUserPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateUserApiV1UnifiedDeactivateUserPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>
  >;
export type DeactivateUserApiV1UnifiedDeactivateUserPostMutationBody =
  DeactivateUnifiedUserRequest;
export type DeactivateUserApiV1UnifiedDeactivateUserPostMutationError =
  HTTPValidationError;

/**
 * @summary Deactivate User
 */
export const useDeactivateUserApiV1UnifiedDeactivateUserPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>,
      TError,
      {
        data: DeactivateUnifiedUserRequest;
        params: DeactivateUserApiV1UnifiedDeactivateUserPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivateUserApiV1UnifiedDeactivateUserPost>>,
  TError,
  {
    data: DeactivateUnifiedUserRequest;
    params: DeactivateUserApiV1UnifiedDeactivateUserPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getDeactivateUserApiV1UnifiedDeactivateUserPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Generate Profile Token (patched: optional params, per-call request)
 */
export const generateProfileTokenApiV1UnifiedGenerateProfileTokenPost = (
  generateProfileTokenRequest: GenerateProfileTokenRequest,
  params:
    | GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams
    | undefined,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/generate-profile-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateProfileTokenRequest,
      ...(params != null ? { params } : {}),
      signal,
    },
    options,
  );
};

export const getGenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost
        >
      >,
      TError,
      {
        data: GenerateProfileTokenRequest;
        params?: GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams;
        request?: SecondParameter<typeof customInstance>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost
      >
    >,
    TError,
    {
      data: GenerateProfileTokenRequest;
      params?: GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams;
      request?: SecondParameter<typeof customInstance>;
    },
    TContext
  > => {
    const mutationKey = [
      "generateProfileTokenApiV1UnifiedGenerateProfileTokenPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost
        >
      >,
      {
        data: GenerateProfileTokenRequest;
        params?: GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams;
        request?: SecondParameter<typeof customInstance>;
      }
    > = (props) => {
      const { data, params, request } = props ?? {};

      return generateProfileTokenApiV1UnifiedGenerateProfileTokenPost(
        data,
        params,
        { ...requestOptions, ...request },
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost
      >
    >
  >;
export type GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostMutationBody =
  GenerateProfileTokenRequest;
export type GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Profile Token (patched: optional params, per-call request)
 */
export const useGenerateProfileTokenApiV1UnifiedGenerateProfileTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost
        >
      >,
      TError,
      {
        data: GenerateProfileTokenRequest;
        params?: GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams;
        request?: SecondParameter<typeof customInstance>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof generateProfileTokenApiV1UnifiedGenerateProfileTokenPost>
  >,
  TError,
  {
    data: GenerateProfileTokenRequest;
    params?: GenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostParams;
    request?: SecondParameter<typeof customInstance>;
  },
  TContext
> => {
  const mutationOptions =
    getGenerateProfileTokenApiV1UnifiedGenerateProfileTokenPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Generate Deactivation User Otp
 */
export const generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost =
  (
    generateDeactivationOTPRequest: GenerateDeactivationOTPRequest,
    params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<unknown>(
      {
        url: `/api/v1/unified/generate-deactivation-otp`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: generateDeactivationOTPRequest,
        params,
        signal,
      },
      options,
    );
  };

export const getGenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
        >
      >,
      TError,
      {
        data: GenerateDeactivationOTPRequest;
        params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
      >
    >,
    TError,
    {
      data: GenerateDeactivationOTPRequest;
      params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
        >
      >,
      {
        data: GenerateDeactivationOTPRequest;
        params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
      >
    >
  >;
export type GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostMutationBody =
  GenerateDeactivationOTPRequest;
export type GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Deactivation User Otp
 */
export const useGenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
          >
        >,
        TError,
        {
          data: GenerateDeactivationOTPRequest;
          params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams;
        },
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPost
      >
    >,
    TError,
    {
      data: GenerateDeactivationOTPRequest;
      params: GenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getGenerateDeactivationUserOtpApiV1UnifiedGenerateDeactivationOtpPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Bulk Register Response Sheet
 */
export const getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet =
  (
    jobId: string,
    params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<unknown>(
      {
        url: `/api/v1/unified/get-bulk-register-csv/${jobId}`,
        method: "GET",
        params,
        signal,
      },
      options,
    );
  };

export const getGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryKey =
  (
    jobId?: string,
    params?: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  ) => {
    return [
      `/api/v1/unified/get-bulk-register-csv/${jobId}`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
      >
    >,
    TError = HTTPValidationError,
  >(
    jobId: string,
    params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    },
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryKey(
        jobId,
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
        >
      >
    > = ({ signal }) =>
      getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet(
        jobId,
        params,
        requestOptions,
        signal,
      );

    return {
      queryKey,
      queryFn,
      enabled: !!jobId,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
      >
    >
  >;
export type GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryError =
  HTTPValidationError;

export function useGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet<
  TData = Awaited<
    ReturnType<
      typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
    >
  >,
  TError = HTTPValidationError,
>(
  jobId: string,
  params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet<
  TData = Awaited<
    ReturnType<
      typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
    >
  >,
  TError = HTTPValidationError,
>(
  jobId: string,
  params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet<
  TData = Awaited<
    ReturnType<
      typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
    >
  >,
  TError = HTTPValidationError,
>(
  jobId: string,
  params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Bulk Register Response Sheet
 */

export function useGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet<
  TData = Awaited<
    ReturnType<
      typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
    >
  >,
  TError = HTTPValidationError,
>(
  jobId: string,
  params: GetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetBulkRegisterResponseSheetApiV1UnifiedGetBulkRegisterCsvJobIdGetQueryOptions(
      jobId,
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get Job List
 */
export const getJobListApiV1UnifiedGetJobListGet = (
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/v1/unified/get-job-list`, method: "GET", params, signal },
    options,
  );
};

export const getGetJobListApiV1UnifiedGetJobListGetQueryKey = (
  params?: GetJobListApiV1UnifiedGetJobListGetParams,
) => {
  return [`/api/v1/unified/get-job-list`, ...(params ? [params] : [])] as const;
};

export const getGetJobListApiV1UnifiedGetJobListGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
  TError = HTTPValidationError,
>(
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetJobListApiV1UnifiedGetJobListGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>
  > = ({ signal }) =>
    getJobListApiV1UnifiedGetJobListGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetJobListApiV1UnifiedGetJobListGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>
>;
export type GetJobListApiV1UnifiedGetJobListGetQueryError = HTTPValidationError;

export function useGetJobListApiV1UnifiedGetJobListGet<
  TData = Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
  TError = HTTPValidationError,
>(
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
          TError,
          Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJobListApiV1UnifiedGetJobListGet<
  TData = Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
  TError = HTTPValidationError,
>(
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
          TError,
          Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetJobListApiV1UnifiedGetJobListGet<
  TData = Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
  TError = HTTPValidationError,
>(
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Job List
 */

export function useGetJobListApiV1UnifiedGetJobListGet<
  TData = Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
  TError = HTTPValidationError,
>(
  params: GetJobListApiV1UnifiedGetJobListGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getJobListApiV1UnifiedGetJobListGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetJobListApiV1UnifiedGetJobListGetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Forgot Password
 */
export const forgotPasswordApiV1UnifiedForgotPasswordPost = (
  forgotPasswordRequest: ForgotPasswordRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/forgot-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: forgotPasswordRequest,
      signal,
    },
    options,
  );
};

export const getForgotPasswordApiV1UnifiedForgotPasswordPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>,
    TError,
    { data: ForgotPasswordRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>,
  TError,
  { data: ForgotPasswordRequest },
  TContext
> => {
  const mutationKey = ["forgotPasswordApiV1UnifiedForgotPasswordPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>,
    { data: ForgotPasswordRequest }
  > = (props) => {
    const { data } = props ?? {};

    return forgotPasswordApiV1UnifiedForgotPasswordPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordApiV1UnifiedForgotPasswordPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>
  >;
export type ForgotPasswordApiV1UnifiedForgotPasswordPostMutationBody =
  ForgotPasswordRequest;
export type ForgotPasswordApiV1UnifiedForgotPasswordPostMutationError =
  HTTPValidationError;

/**
 * @summary Forgot Password
 */
export const useForgotPasswordApiV1UnifiedForgotPasswordPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>,
      TError,
      { data: ForgotPasswordRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedForgotPasswordPost>>,
  TError,
  { data: ForgotPasswordRequest },
  TContext
> => {
  const mutationOptions =
    getForgotPasswordApiV1UnifiedForgotPasswordPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Forgot Password
 */
export const forgotPasswordApiV1UnifiedValidateUserPost = (
  validateUserRequest: ValidateUserRequest,
  params: ForgotPasswordApiV1UnifiedValidateUserPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/validate-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validateUserRequest,
      params,
      signal,
    },
    options,
  );
};

export const getForgotPasswordApiV1UnifiedValidateUserPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>,
    TError,
    {
      data: ValidateUserRequest;
      params: ForgotPasswordApiV1UnifiedValidateUserPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>,
  TError,
  {
    data: ValidateUserRequest;
    params: ForgotPasswordApiV1UnifiedValidateUserPostParams;
  },
  TContext
> => {
  const mutationKey = ["forgotPasswordApiV1UnifiedValidateUserPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>,
    {
      data: ValidateUserRequest;
      params: ForgotPasswordApiV1UnifiedValidateUserPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return forgotPasswordApiV1UnifiedValidateUserPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordApiV1UnifiedValidateUserPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>
  >;
export type ForgotPasswordApiV1UnifiedValidateUserPostMutationBody =
  ValidateUserRequest;
export type ForgotPasswordApiV1UnifiedValidateUserPostMutationError =
  HTTPValidationError;

/**
 * @summary Forgot Password
 */
export const useForgotPasswordApiV1UnifiedValidateUserPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>,
      TError,
      {
        data: ValidateUserRequest;
        params: ForgotPasswordApiV1UnifiedValidateUserPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof forgotPasswordApiV1UnifiedValidateUserPost>>,
  TError,
  {
    data: ValidateUserRequest;
    params: ForgotPasswordApiV1UnifiedValidateUserPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getForgotPasswordApiV1UnifiedValidateUserPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search User
 */
export const searchUserApiV1UnifiedSearchUserPost = (
  searchProfileRequest: SearchProfileRequest,
  params: SearchUserApiV1UnifiedSearchUserPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/search-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchProfileRequest,
      params,
      signal,
    },
    options,
  );
};

export const getSearchUserApiV1UnifiedSearchUserPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>,
    TError,
    {
      data: SearchProfileRequest;
      params: SearchUserApiV1UnifiedSearchUserPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>,
  TError,
  {
    data: SearchProfileRequest;
    params: SearchUserApiV1UnifiedSearchUserPostParams;
  },
  TContext
> => {
  const mutationKey = ["searchUserApiV1UnifiedSearchUserPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>,
    {
      data: SearchProfileRequest;
      params: SearchUserApiV1UnifiedSearchUserPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return searchUserApiV1UnifiedSearchUserPost(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchUserApiV1UnifiedSearchUserPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>
>;
export type SearchUserApiV1UnifiedSearchUserPostMutationBody =
  SearchProfileRequest;
export type SearchUserApiV1UnifiedSearchUserPostMutationError =
  HTTPValidationError;

/**
 * @summary Search User
 */
export const useSearchUserApiV1UnifiedSearchUserPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>,
      TError,
      {
        data: SearchProfileRequest;
        params: SearchUserApiV1UnifiedSearchUserPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchUserApiV1UnifiedSearchUserPost>>,
  TError,
  {
    data: SearchProfileRequest;
    params: SearchUserApiV1UnifiedSearchUserPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getSearchUserApiV1UnifiedSearchUserPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Refresh Token
 */
export const refreshTokenApiV1UnifiedRefreshProfileTokenPost = (
  profileRefreshTokenRequest: ProfileRefreshTokenRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/refresh-profile-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: profileRefreshTokenRequest,
      signal,
    },
    options,
  );
};

export const getRefreshTokenApiV1UnifiedRefreshProfileTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>
      >,
      TError,
      { data: ProfileRefreshTokenRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>>,
    TError,
    { data: ProfileRefreshTokenRequest },
    TContext
  > => {
    const mutationKey = ["refreshTokenApiV1UnifiedRefreshProfileTokenPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>
      >,
      { data: ProfileRefreshTokenRequest }
    > = (props) => {
      const { data } = props ?? {};

      return refreshTokenApiV1UnifiedRefreshProfileTokenPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RefreshTokenApiV1UnifiedRefreshProfileTokenPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>>
  >;
export type RefreshTokenApiV1UnifiedRefreshProfileTokenPostMutationBody =
  ProfileRefreshTokenRequest;
export type RefreshTokenApiV1UnifiedRefreshProfileTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Refresh Token
 */
export const useRefreshTokenApiV1UnifiedRefreshProfileTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>
      >,
      TError,
      { data: ProfileRefreshTokenRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshTokenApiV1UnifiedRefreshProfileTokenPost>>,
  TError,
  { data: ProfileRefreshTokenRequest },
  TContext
> => {
  const mutationOptions =
    getRefreshTokenApiV1UnifiedRefreshProfileTokenPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Bulk Search
 */
export const bulkSearchApiV1UnifiedBulkSearchPost = (
  bulkSearchUserRequest: BulkSearchUserRequest,
  params: BulkSearchApiV1UnifiedBulkSearchPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/bulk-search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkSearchUserRequest,
      params,
      signal,
    },
    options,
  );
};

export const getBulkSearchApiV1UnifiedBulkSearchPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>,
    TError,
    {
      data: BulkSearchUserRequest;
      params: BulkSearchApiV1UnifiedBulkSearchPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>,
  TError,
  {
    data: BulkSearchUserRequest;
    params: BulkSearchApiV1UnifiedBulkSearchPostParams;
  },
  TContext
> => {
  const mutationKey = ["bulkSearchApiV1UnifiedBulkSearchPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>,
    {
      data: BulkSearchUserRequest;
      params: BulkSearchApiV1UnifiedBulkSearchPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return bulkSearchApiV1UnifiedBulkSearchPost(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkSearchApiV1UnifiedBulkSearchPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>
>;
export type BulkSearchApiV1UnifiedBulkSearchPostMutationBody =
  BulkSearchUserRequest;
export type BulkSearchApiV1UnifiedBulkSearchPostMutationError =
  HTTPValidationError;

/**
 * @summary Bulk Search
 */
export const useBulkSearchApiV1UnifiedBulkSearchPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>,
      TError,
      {
        data: BulkSearchUserRequest;
        params: BulkSearchApiV1UnifiedBulkSearchPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkSearchApiV1UnifiedBulkSearchPost>>,
  TError,
  {
    data: BulkSearchUserRequest;
    params: BulkSearchApiV1UnifiedBulkSearchPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getBulkSearchApiV1UnifiedBulkSearchPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Batch Register
 */
export const batchRegisterApiV1UnifiedBatchRegisterPost = (
  multiUserRegistrationRequest: MultiUserRegistrationRequest,
  params: BatchRegisterApiV1UnifiedBatchRegisterPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BatchUserRegistrationResponse>(
    {
      url: `/api/v1/unified/batch-register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: multiUserRegistrationRequest,
      params,
      signal,
    },
    options,
  );
};

export const getBatchRegisterApiV1UnifiedBatchRegisterPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>,
    TError,
    {
      data: MultiUserRegistrationRequest;
      params: BatchRegisterApiV1UnifiedBatchRegisterPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>,
  TError,
  {
    data: MultiUserRegistrationRequest;
    params: BatchRegisterApiV1UnifiedBatchRegisterPostParams;
  },
  TContext
> => {
  const mutationKey = ["batchRegisterApiV1UnifiedBatchRegisterPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>,
    {
      data: MultiUserRegistrationRequest;
      params: BatchRegisterApiV1UnifiedBatchRegisterPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return batchRegisterApiV1UnifiedBatchRegisterPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type BatchRegisterApiV1UnifiedBatchRegisterPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>
  >;
export type BatchRegisterApiV1UnifiedBatchRegisterPostMutationBody =
  MultiUserRegistrationRequest;
export type BatchRegisterApiV1UnifiedBatchRegisterPostMutationError =
  HTTPValidationError;

/**
 * @summary Batch Register
 */
export const useBatchRegisterApiV1UnifiedBatchRegisterPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>,
      TError,
      {
        data: MultiUserRegistrationRequest;
        params: BatchRegisterApiV1UnifiedBatchRegisterPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof batchRegisterApiV1UnifiedBatchRegisterPost>>,
  TError,
  {
    data: MultiUserRegistrationRequest;
    params: BatchRegisterApiV1UnifiedBatchRegisterPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getBatchRegisterApiV1UnifiedBatchRegisterPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create Username And Password
 */
export const createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost =
  (
    createUsernameAndPasswordRequest: CreateUsernameAndPasswordRequest,
    params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<unknown>(
      {
        url: `/api/v1/unified/create-username-and-password`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: createUsernameAndPasswordRequest,
        params,
        signal,
      },
      options,
    );
  };

export const getCreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
        >
      >,
      TError,
      {
        data: CreateUsernameAndPasswordRequest;
        params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
      >
    >,
    TError,
    {
      data: CreateUsernameAndPasswordRequest;
      params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
        >
      >,
      {
        data: CreateUsernameAndPasswordRequest;
        params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
      >
    >
  >;
export type CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostMutationBody =
  CreateUsernameAndPasswordRequest;
export type CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Username And Password
 */
export const useCreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
          >
        >,
        TError,
        {
          data: CreateUsernameAndPasswordRequest;
          params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams;
        },
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPost
      >
    >,
    TError,
    {
      data: CreateUsernameAndPasswordRequest;
      params: CreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getCreateUsernameAndPasswordApiV1UnifiedCreateUsernameAndPasswordPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Change Password
 */
export const changePasswordApiV1UnifiedChangePasswordPost = (
  changePasswordRequest: ChangePasswordRequest,
  params: ChangePasswordApiV1UnifiedChangePasswordPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v1/unified/change-password`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePasswordRequest,
      params,
      signal,
    },
    options,
  );
};

export const getChangePasswordApiV1UnifiedChangePasswordPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>,
    TError,
    {
      data: ChangePasswordRequest;
      params: ChangePasswordApiV1UnifiedChangePasswordPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>,
  TError,
  {
    data: ChangePasswordRequest;
    params: ChangePasswordApiV1UnifiedChangePasswordPostParams;
  },
  TContext
> => {
  const mutationKey = ["changePasswordApiV1UnifiedChangePasswordPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>,
    {
      data: ChangePasswordRequest;
      params: ChangePasswordApiV1UnifiedChangePasswordPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return changePasswordApiV1UnifiedChangePasswordPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePasswordApiV1UnifiedChangePasswordPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>
  >;
export type ChangePasswordApiV1UnifiedChangePasswordPostMutationBody =
  ChangePasswordRequest;
export type ChangePasswordApiV1UnifiedChangePasswordPostMutationError =
  HTTPValidationError;

/**
 * @summary Change Password
 */
export const useChangePasswordApiV1UnifiedChangePasswordPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>,
      TError,
      {
        data: ChangePasswordRequest;
        params: ChangePasswordApiV1UnifiedChangePasswordPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof changePasswordApiV1UnifiedChangePasswordPost>>,
  TError,
  {
    data: ChangePasswordRequest;
    params: ChangePasswordApiV1UnifiedChangePasswordPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getChangePasswordApiV1UnifiedChangePasswordPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Change Phone Number
 */
export const changePhoneNumberApiV1UnifiedChangePhoneNumberPost = (
  changePhoneNumberRequest: ChangePhoneNumberRequest,
  params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChangePhoneNumberResponse>(
    {
      url: `/api/v1/unified/change-phone-number`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePhoneNumberRequest,
      params,
      signal,
    },
    options,
  );
};

export const getChangePhoneNumberApiV1UnifiedChangePhoneNumberPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
      >,
      TError,
      {
        data: ChangePhoneNumberRequest;
        params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
    >,
    TError,
    {
      data: ChangePhoneNumberRequest;
      params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams;
    },
    TContext
  > => {
    const mutationKey = ["changePhoneNumberApiV1UnifiedChangePhoneNumberPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
      >,
      {
        data: ChangePhoneNumberRequest;
        params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return changePhoneNumberApiV1UnifiedChangePhoneNumberPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
    >
  >;
export type ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostMutationBody =
  ChangePhoneNumberRequest;
export type ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostMutationError =
  HTTPValidationError;

/**
 * @summary Change Phone Number
 */

export type ApiErrorResponse = {
  status: "failed" | string;
  error_code?: string;
  message?: string;
  data?: unknown;
};

export const useChangePhoneNumberApiV1UnifiedChangePhoneNumberPost = <
  TError = any,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
      >,
      TError,
      {
        data: ChangePhoneNumberRequest;
        params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof changePhoneNumberApiV1UnifiedChangePhoneNumberPost>
  >,
  TError,
  {
    data: ChangePhoneNumberRequest;
    params: ChangePhoneNumberApiV1UnifiedChangePhoneNumberPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getChangePhoneNumberApiV1UnifiedChangePhoneNumberPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get User Details
 */
export const getUserDetailsApiV1UnifiedGetUserDetailsGet = (
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/v1/unified/get-user-details`, method: "GET", params, signal },
    options,
  );
};

export const getGetUserDetailsApiV1UnifiedGetUserDetailsGetQueryKey = (
  params?: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
) => {
  return [
    `/api/v1/unified/get-user-details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetUserDetailsApiV1UnifiedGetUserDetailsGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserDetailsApiV1UnifiedGetUserDetailsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>
  > = ({ signal }) =>
    getUserDetailsApiV1UnifiedGetUserDetailsGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserDetailsApiV1UnifiedGetUserDetailsGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>
  >;
export type GetUserDetailsApiV1UnifiedGetUserDetailsGetQueryError =
  HTTPValidationError;

export function useGetUserDetailsApiV1UnifiedGetUserDetailsGet<
  TData = Awaited<
    ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserDetailsApiV1UnifiedGetUserDetailsGet<
  TData = Awaited<
    ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserDetailsApiV1UnifiedGetUserDetailsGet<
  TData = Awaited<
    ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Details
 */

export function useGetUserDetailsApiV1UnifiedGetUserDetailsGet<
  TData = Awaited<
    ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetUserDetailsApiV1UnifiedGetUserDetailsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserDetailsApiV1UnifiedGetUserDetailsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetUserDetailsApiV1UnifiedGetUserDetailsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * MagicMock is a subclass of Mock with default implementations
of most of the magic methods. You can use MagicMock without having to
configure the magic methods yourself.

If you use the `spec` or `spec_set` arguments then *only* magic
methods that exist in the spec will be created.

Attributes and the return value of a `MagicMock` will also be `MagicMocks`.
 * @summary Magicmock
 */
export const magicMockApiV2UnifiedLoginWithOtpPost = (
  params: MagicMockApiV2UnifiedLoginWithOtpPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/v2/unified/login-with-otp`, method: "POST", params, signal },
    options,
  );
};

export const getMagicMockApiV2UnifiedLoginWithOtpPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>,
    TError,
    { params: MagicMockApiV2UnifiedLoginWithOtpPostParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>,
  TError,
  { params: MagicMockApiV2UnifiedLoginWithOtpPostParams },
  TContext
> => {
  const mutationKey = ["magicMockApiV2UnifiedLoginWithOtpPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>,
    { params: MagicMockApiV2UnifiedLoginWithOtpPostParams }
  > = (props) => {
    const { params } = props ?? {};

    return magicMockApiV2UnifiedLoginWithOtpPost(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV2UnifiedLoginWithOtpPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>
>;

export type MagicMockApiV2UnifiedLoginWithOtpPostMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock
 */
export const useMagicMockApiV2UnifiedLoginWithOtpPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>,
      TError,
      { params: MagicMockApiV2UnifiedLoginWithOtpPostParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithOtpPost>>,
  TError,
  { params: MagicMockApiV2UnifiedLoginWithOtpPostParams },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV2UnifiedLoginWithOtpPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * MagicMock is a subclass of Mock with default implementations
of most of the magic methods. You can use MagicMock without having to
configure the magic methods yourself.

If you use the `spec` or `spec_set` arguments then *only* magic
methods that exist in the spec will be created.

Attributes and the return value of a `MagicMock` will also be `MagicMocks`.
 * @summary Magicmock
 */
export const magicMockApiV2UnifiedLoginWithAdmissionIdPost = (
  params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v2/unified/login-with-admission-id`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getMagicMockApiV2UnifiedLoginWithAdmissionIdPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>,
    TError,
    { params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>,
  TError,
  { params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams },
  TContext
> => {
  const mutationKey = ["magicMockApiV2UnifiedLoginWithAdmissionIdPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>,
    { params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams }
  > = (props) => {
    const { params } = props ?? {};

    return magicMockApiV2UnifiedLoginWithAdmissionIdPost(
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type MagicMockApiV2UnifiedLoginWithAdmissionIdPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>
  >;

export type MagicMockApiV2UnifiedLoginWithAdmissionIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Magicmock
 */
export const useMagicMockApiV2UnifiedLoginWithAdmissionIdPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>,
      TError,
      { params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof magicMockApiV2UnifiedLoginWithAdmissionIdPost>>,
  TError,
  { params: MagicMockApiV2UnifiedLoginWithAdmissionIdPostParams },
  TContext
> => {
  const mutationOptions =
    getMagicMockApiV2UnifiedLoginWithAdmissionIdPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Generate Encrypted Profile Token
 */
export const generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost =
  (
    generateProfileTokenRequest: GenerateProfileTokenRequest,
    params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
  ) => {
    return customInstance<unknown>(
      {
        url: `/api/v2/unified/generate-profile-token`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: generateProfileTokenRequest,
        params,
        signal,
      },
      options,
    );
  };

export const getGenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
        >
      >,
      TError,
      {
        data: GenerateProfileTokenRequest;
        params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
      >
    >,
    TError,
    {
      data: GenerateProfileTokenRequest;
      params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
        >
      >,
      {
        data: GenerateProfileTokenRequest;
        params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
      >
    >
  >;
export type GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostMutationBody =
  GenerateProfileTokenRequest;
export type GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Encrypted Profile Token
 */
export const useGenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
          >
        >,
        TError,
        {
          data: GenerateProfileTokenRequest;
          params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams;
        },
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof generateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPost
      >
    >,
    TError,
    {
      data: GenerateProfileTokenRequest;
      params: GenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getGenerateEncryptedProfileTokenApiV2UnifiedGenerateProfileTokenPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Refresh Encrypted Token
 */
export const refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost = (
  profileRefreshTokenRequestV3: ProfileRefreshTokenRequestV3,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v2/unified/refresh-profile-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: profileRefreshTokenRequestV3,
      signal,
    },
    options,
  );
};

export const getRefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost
        >
      >,
      TError,
      { data: ProfileRefreshTokenRequestV3 },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost
      >
    >,
    TError,
    { data: ProfileRefreshTokenRequestV3 },
    TContext
  > => {
    const mutationKey = [
      "refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost
        >
      >,
      { data: ProfileRefreshTokenRequestV3 }
    > = (props) => {
      const { data } = props ?? {};

      return refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost
      >
    >
  >;
export type RefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPostMutationBody =
  ProfileRefreshTokenRequestV3;
export type RefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Refresh Encrypted Token
 */
export const useRefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost
        >
      >,
      TError,
      { data: ProfileRefreshTokenRequestV3 },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof refreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPost>
  >,
  TError,
  { data: ProfileRefreshTokenRequestV3 },
  TContext
> => {
  const mutationOptions =
    getRefreshEncryptedTokenApiV2UnifiedRefreshProfileTokenPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Encrypted Logout Unified User
 */
export const encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost = (
  logoutRequest: LogoutRequest,
  params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v2/unified/logout`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: logoutRequest,
      params,
      signal,
    },
    options,
  );
};

export const getEncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>
      >,
      TError,
      {
        data: LogoutRequest;
        params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>
    >,
    TError,
    {
      data: LogoutRequest;
      params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams;
    },
    TContext
  > => {
    const mutationKey = ["encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>
      >,
      {
        data: LogoutRequest;
        params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost(
        data,
        params,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>>
  >;
export type EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostMutationBody =
  LogoutRequest;
export type EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostMutationError =
  HTTPValidationError;

/**
 * @summary Encrypted Logout Unified User
 */
export const useEncryptedLogoutUnifiedUserApiV2UnifiedLogoutPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>
      >,
      TError,
      {
        data: LogoutRequest;
        params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof encryptedLogoutUnifiedUserApiV2UnifiedLogoutPost>>,
  TError,
  {
    data: LogoutRequest;
    params: EncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getEncryptedLogoutUnifiedUserApiV2UnifiedLogoutPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Search User Handler
 */
export const searchUserHandlerApiV2UnifiedSearchUserPost = (
  searchProfileRequest: SearchProfileRequest,
  params: SearchUserHandlerApiV2UnifiedSearchUserPostParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v2/unified/search-user`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchProfileRequest,
      params,
      signal,
    },
    options,
  );
};

export const getSearchUserHandlerApiV2UnifiedSearchUserPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>,
    TError,
    {
      data: SearchProfileRequest;
      params: SearchUserHandlerApiV2UnifiedSearchUserPostParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>,
  TError,
  {
    data: SearchProfileRequest;
    params: SearchUserHandlerApiV2UnifiedSearchUserPostParams;
  },
  TContext
> => {
  const mutationKey = ["searchUserHandlerApiV2UnifiedSearchUserPost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>,
    {
      data: SearchProfileRequest;
      params: SearchUserHandlerApiV2UnifiedSearchUserPostParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return searchUserHandlerApiV2UnifiedSearchUserPost(
      data,
      params,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchUserHandlerApiV2UnifiedSearchUserPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>
  >;
export type SearchUserHandlerApiV2UnifiedSearchUserPostMutationBody =
  SearchProfileRequest;
export type SearchUserHandlerApiV2UnifiedSearchUserPostMutationError =
  HTTPValidationError;

/**
 * @summary Search User Handler
 */
export const useSearchUserHandlerApiV2UnifiedSearchUserPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>,
      TError,
      {
        data: SearchProfileRequest;
        params: SearchUserHandlerApiV2UnifiedSearchUserPostParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchUserHandlerApiV2UnifiedSearchUserPost>>,
  TError,
  {
    data: SearchProfileRequest;
    params: SearchUserHandlerApiV2UnifiedSearchUserPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getSearchUserHandlerApiV2UnifiedSearchUserPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Refresh Token V3
 */
export const refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost = (
  profileRefreshTokenRequestV3: ProfileRefreshTokenRequestV3,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/v3/unified/refresh-profile-token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: profileRefreshTokenRequestV3,
      signal,
    },
    options,
  );
};

export const getRefreshTokenV3ApiV3UnifiedRefreshProfileTokenPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>
      >,
      TError,
      { data: ProfileRefreshTokenRequestV3 },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>
    >,
    TError,
    { data: ProfileRefreshTokenRequestV3 },
    TContext
  > => {
    const mutationKey = ["refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>
      >,
      { data: ProfileRefreshTokenRequestV3 }
    > = (props) => {
      const { data } = props ?? {};

      return refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost(
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RefreshTokenV3ApiV3UnifiedRefreshProfileTokenPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>
    >
  >;
export type RefreshTokenV3ApiV3UnifiedRefreshProfileTokenPostMutationBody =
  ProfileRefreshTokenRequestV3;
export type RefreshTokenV3ApiV3UnifiedRefreshProfileTokenPostMutationError =
  HTTPValidationError;

/**
 * @summary Refresh Token V3
 */
export const useRefreshTokenV3ApiV3UnifiedRefreshProfileTokenPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>
      >,
      TError,
      { data: ProfileRefreshTokenRequestV3 },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshTokenV3ApiV3UnifiedRefreshProfileTokenPost>>,
  TError,
  { data: ProfileRefreshTokenRequestV3 },
  TContext
> => {
  const mutationOptions =
    getRefreshTokenV3ApiV3UnifiedRefreshProfileTokenPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
